import React, { useState, useEffect } from 'react';
import ModalBootstrap from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { captureMessage } from '@sentry/react';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/actions';
import CloseButton from '../../common/CloseButton';
import axios from 'axios';

const source = axios.CancelToken.source();

const BlockUser = ({
    user,
    show,
    setShow,
    handleBlockModal,
    getBlockedUsers,
}) => {
    const dispatch = useDispatch();

    const [isBusy, setIsBusy] = useState(false);
    const [blockType, setBlockType] = useState('no-refund');
    const [follower, setFollower] = useState({});
    const [gettingFollower, setGettingFollower] = useState(false);

    const handleSelectType = (e) => {
        setBlockType(e.target.value);
    };

    const handleSubmit = () => {
        setIsBusy(true);
        axios.post('/api/blocks', {
            su: user.id,
            block_type: blockType,
        }, {
            CancelToken: source.token
        })
            .then(response => {
                getBlockedUsers();
                setIsBusy(false);
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'User successfully blocked'
                }));
                handleBlockModal();
            })
            .catch((error) => {
                setIsBusy(false);
                captureMessage(error);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: `Blocking ${user.login} failed`
                }));
            });
    };

    const checkFollowStatus = async () => {
        setGettingFollower(true);
        await axios.get(`/api/followers/follower`, {
            params: {
                su: user.id
            }
        }, {
            CancelToken: source.token
        })
            .then(response => {
                setFollower(response.data);
                setGettingFollower(false);
            })
            .catch(error => {
                setGettingFollower(false);
            });
    };

    useEffect(() => {
        checkFollowStatus();
        return () => {
            source.cancel();
        };
    }, []);


    return <ModalBootstrap
        // showBlockModal
        show={show}
        onHide={handleBlockModal}
        className="blockuser-modal"
        centered
    >
        <ModalBootstrap.Header >
            <ModalBootstrap.Title>
                Block @{user ? user.login : ''}

                <CloseButton
                    disabled={isBusy}
                    className="close"
                    onClick={handleBlockModal}
                    style={{ position: 'absolute', top: '20px', right: '12px' }}
                />
            </ModalBootstrap.Title>
        </ModalBootstrap.Header>
        <ModalBootstrap.Body>
            <div className="block-selection">
                <Form>
                    {[0, 2].includes(follower.tier) && <React.Fragment>
                        <Form.Check
                            label="Refund Subscription"
                            name="block-selection"
                            type="radio"
                            checked={blockType === 'refund'}
                            onChange={handleSelectType}
                            value="refund"
                        />
                        <Form.Check
                            label="Do NOT refund subscription"
                            name="block-selection"
                            type="radio"
                            checked={blockType === 'no-refund'}
                            onChange={handleSelectType}
                            value="no-refund"
                        />
                        <p>
                            <b>Important Notice</b><br />
                            Depending on the reason for blocking it's a good idea to consider refunding to reduce the risk of the subscriber submitting a chargeback. Chargebacks are automaticcaly deducted from your account by the subscribers bank and their bank also deducts an additional fee. For more information about chargebacks and prevention. <a href="https://priva.uvdesk.com/en//articles/360015980713-What-are-my-responsibilities-as-a-Privaposts-creator" target="_blank">See link</a>.
                        </p>
                    </React.Fragment>
                    }
                    {
                        isBusy
                            ? <div className="block-btn-container">
                                <button type="button" className="btn btn-primary btn-rounded" disabled={isBusy}>Cancel</button>
                                <button type="button" className="btn btn-primary btn-rounded" disabled={isBusy}>Submitting...</button>
                            </div>
                            : <div className="block-btn-container">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-rounded"
                                    onClick={handleBlockModal}
                                >Cancel</button>
                                <button
                                    type="button"
                                    className="btn btn-primary btn-rounded"
                                    onClick={handleSubmit}
                                    disabled={gettingFollower}
                                >Submit</button>
                            </div>
                    }
                </Form>
            </div>
        </ModalBootstrap.Body>
    </ModalBootstrap>;
};

export default BlockUser;
